import { render, staticRenderFns } from "./AlbumList--Cards.vue?vue&type=template&id=5427591b&lang=pug&"
import script from "./AlbumList--Cards.vue?vue&type=script&lang=js&"
export * from "./AlbumList--Cards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports